// extracted by mini-css-extract-plugin
export default {"wrapper":"inputWithArrows_wrapper__4iSCf","arrow":"inputWithArrows_arrow__3GNus"};